<template>
  <Layout>
    <div class="dygaoyong-page">
      <div class="page-content">
        <!-- 页面头部 -->
        <div class="page-header">
          <div class="header-search">
            <el-autocomplete
              ref="searchAutocomplete"
              v-model="searchKeyword"
              placeholder="支持抖口令、商品链接、商品标题搜索"
              class="search-input-large"
              clearable
              :fetch-suggestions="querySearchAsync"
              :trigger-on-focus="false"
              autosize
              @select="handleSuggestSelect"
              @keyup.enter.native="handleSearch"
              @clear="handleSearchClear"
            >
              <el-button slot="append" type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </el-autocomplete>
          </div>
        </div>

        <!-- 搜索逻辑说明 -->
      <el-alert
        v-if="isSearchMode"
        type="info"
        :closable="false"
        class="compact-tip"
      >
        <template slot="title">
          <div class="compact-content">
            <span class="tag">单品精准搜索</span> 商品链接/抖口令/数字商品ID → 抖客CPS → 高佣库对比择优 → 高佣库无品推荐兜底
            <span class="divider">|</span>
            <span class="tag">关键词搜索</span> P1高佣库 / P2+抖客CPS(去重，P1中出现过的高佣库同商品不再展示)
            <span class="divider">|</span>
            <span class="tag limit">⚠️限制</span> 高佣库搜索结果不支持翻页，MAX 20条
          </div>
        </template>
      </el-alert>

        <!-- 筛选区域 -->
        <el-card v-if="!isSearchMode" class="card-container" shadow="never">
          <div class="filter-section">
            <!-- 时间筛选 -->
            <div class="filter-group">
              <label class="filter-label">时间范围：</label>
              <el-radio-group v-model="timeEnum" @change="handleTimeChange">
                <el-radio-button v-for="time in timeList" :key="time.value" :label="time.value">{{
                  time.name
                }}</el-radio-button>
              </el-radio-group>
            </div>

            <!-- 类目筛选 -->
            <div class="filter-group">
              <label class="filter-label">商品类目：</label>
              <el-radio-group v-model="categoryEnum" @change="handleCategoryChange">
                <el-radio-button v-for="category in categoryList" :key="category.value" :label="category.value">{{
                  category.name
                }}</el-radio-button>
              </el-radio-group>
            </div>

            <!-- 排序选择 -->
            <div class="filter-group">
              <label class="filter-label">排序方式：</label>
              <div class="sort-buttons">
                <div
                  class="sort-item"
                  :class="{ active: sortField === 'sales_num' }"
                  @click="handleSortClick('sales_num')"
                >
                  <span class="sort-label">销量</span>
                  <div class="sort-arrows">
                    <i
                      class="el-icon-arrow-up"
                      :class="{ active: sortField === 'sales_num' && sortOrder === 'asc' }"
                      @click.stop="handleSortClick('sales_num', 'asc')"
                    ></i>
                    <i
                      class="el-icon-arrow-down"
                      :class="{ active: sortField === 'sales_num' && sortOrder === 'desc' }"
                      @click.stop="handleSortClick('sales_num', 'desc')"
                    ></i>
                  </div>
                </div>
                <div
                  class="sort-item"
                  :class="{ active: sortField === 'final_price' }"
                  @click="handleSortClick('final_price')"
                >
                  <span class="sort-label">价格</span>
                  <div class="sort-arrows">
                    <i
                      class="el-icon-arrow-up"
                      :class="{ active: sortField === 'final_price' && sortOrder === 'asc' }"
                      @click.stop="handleSortClick('final_price', 'asc')"
                    ></i>
                    <i
                      class="el-icon-arrow-down"
                      :class="{ active: sortField === 'final_price' && sortOrder === 'desc' }"
                      @click.stop="handleSortClick('final_price', 'desc')"
                    ></i>
                  </div>
                </div>
                <div
                  class="sort-item"
                  :class="{ active: sortField === 'tkrates_raw' }"
                  @click="handleSortClick('tkrates_raw')"
                >
                  <span class="sort-label">佣金比例</span>
                  <div class="sort-arrows">
                    <i
                      class="el-icon-arrow-up"
                      :class="{ active: sortField === 'tkrates_raw' && sortOrder === 'asc' }"
                      @click.stop="handleSortClick('tkrates_raw', 'asc')"
                    ></i>
                    <i
                      class="el-icon-arrow-down"
                      :class="{ active: sortField === 'tkrates_raw' && sortOrder === 'desc' }"
                      @click.stop="handleSortClick('tkrates_raw', 'desc')"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 商品列表 -->
        <div class="goods-list" v-loading="loading || searchLoading || noProductRecommendLoading">
          <!-- 无品推荐标题 -->
          <div v-if="showNoProductRecommend && noProductRecommendList.length > 0" class="recommend-title">
            <h3>以下结果来自高佣接口无品推荐</h3>
          </div>

          <!-- 无品推荐也为空的提示 -->
          <div
            v-if="
              isSearchMode &&
              searchList.length === 0 &&
              noProductRecommendList.length === 0 &&
              !searchLoading &&
              !noProductRecommendLoading
            "
            class="empty-data"
          >
            该商品无CPS且高佣接口无品推荐也为空!
          </div>

          <!-- 普通空数据提示 -->
          <div
            v-else-if="
              sortedGoodsList.length === 0 &&
              (!isSearchMode || (searchList.length === 0 && noProductRecommendList.length === 0))
            "
            class="empty-data"
          >
            {{
              loading || searchLoading || noProductRecommendLoading
                ? "数据加载中..."
                : isSearchMode
                ? "未找到相关商品，请尝试其他关键词"
                : "暂无商品数据，请尝试切换其他条件"
            }}
          </div>

          <!-- 商品网格布局 -->
          <div
            class="goods-grid"
            v-if="sortedGoodsList.length > 0"
            :class="{ 'single-goods-card': sortedGoodsList.length === 1 }"
          >
            <div
              class="goods-item"
              v-for="(item, index) in sortedGoodsList"
              :key="`${item.origin_id || index}-${sortField}-${sortOrder}`"
            >
              <div class="goods-card">
                <!-- 商品图片 -->
                <div class="goods-image">
                  <el-image
                    :key="`img-${item.origin_id}-${index}-${timeEnum}-${categoryEnum}-${sortField}-${sortOrder}`"
                    :src="item.image || defaultImage"
                    :preview-src-list="[item.image || defaultImage]"
                    fit="contain"
                    lazy
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>

                <!-- 商品信息 -->
                <div class="goods-content">
                  <!-- 商品标题 -->
                  <div class="goods-title" :title="item.title" @click="handleOpenGoods(item)">
                    <!-- <el-tag
                      size="mini"
                      class="platform-tag"
                      :style="{ backgroundColor: '#000000', color: '#fff', borderColor: '#000000' }"
                      >抖音</el-tag
                    > -->
                    <el-tag
                      v-if="item.is_dy_cpm"
                      size="mini"
                      :style="{ backgroundColor: '#ff3b52', color: '#fff', borderColor: '#d61a30' }"
                      effect="dark"
                      class="cpm-tag"
                      >高佣库</el-tag
                    >
                    {{ item.title }}
                  </div>

                  <!-- 店铺&销量信息 -->
                  <div class="sales-info-container">
                    <div class="shop-title"><i class="el-icon-shopping-bag-1"></i>{{ item.shop_title }}</div>
                    <div class="sales-info" v-if="item.sales_num">
                      <span class="sales-text">已售{{ formatSales(item.sales_num) }}</span>
                    </div>
                  </div>

                  <!-- 佣金率对比（搜索模式且单条结果时显示） -->
                  <div
                    class="commission-pk-container"
                    v-if="isSearchMode && searchList.length === 1 && item.pgl_rate !== undefined"
                  >
                    <div class="pk-item loser">
                      <div class="label">抖客佣金</div>
                      <div class="value">{{ item.pgl_rate }}%</div>
                    </div>

                    <div class="pk-divider">
                      <span class="vs-tag">VS</span>
                    </div>

                    <div class="pk-item winner">
                      <div class="badge">推荐</div>
                      <div class="label">高佣佣金</div>
                      <div class="value-group">
                        <span class="num">{{ item.tkrates_raw }}%</span>
                        <span class="up-tag">↑{{ (item.tkrates_raw - item.pgl_rate).toFixed(2) }}%</span>
                      </div>
                    </div>
                  </div>

                  <!-- 价格区域 -->
                  <div class="price-row">
                    <div class="price-info">
                      <div class="current-price">
                        ￥<span class="price-number customFont">{{ item.final_price || item.origin_price }}</span>
                      </div>
                      <div class="original-price">￥{{ item.origin_price }}</div>
                    </div>

                    <!-- 优惠标签 -->
                    <div class="goods-tags">
                      <!-- <el-tag v-if="item.coupon_price" type="danger" effect="dark" class="price-tag"
                        >券￥{{ item.coupon_price }}</el-tag
                      > -->
                      <div class="commission-rate">佣金率{{ item.tkrates_raw }}%</div>
                      <div class="commission-text">
                        赚￥<span class="number customFont">{{
                          formatNumber((item.tkrates_raw * item.final_price) / 100)
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- 商品ID和操作 -->
                  <div class="action-row">
                    <div class="goods-id" @click="copyGoodsId(item.origin_id)">
                      <el-tooltip content="点击复制商品ID" placement="top">
                        <span class="id-text"> <i class="el-icon-copy-document"></i> 复制ID </span>
                      </el-tooltip>
                    </div>
                    <div class="goods-id" @click="copyGoodsLink(item.detail_url+'&origin_type=pc_buyin_group')" v-if="item.detail_url">
                      <el-tooltip content="点击复制商品链接" placement="top">
                        <span class="id-text"> <i class="el-icon-link"></i> 复制链接 </span>
                      </el-tooltip>
                    </div>
                    <el-button type="primary" size="mini" @click="handleGoodsClick(item)">立即推广</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 推广结果弹窗 -->
    <el-dialog
      title="推广链接"
      :visible.sync="promoteDialogVisible"
      width="560px"
      class="promote-dialog"
      @close="handlePromoteDialogClose"
    >
      <div v-loading="promoteLoading" class="promote-result">
        <div v-if="!promoteLoading && promoteResult" class="promote-fields">
          <div class="promote-field">
            <label>抖音口令</label>
            <div class="field-value">
              <el-input :value="promoteResult.dy_password" type="textarea" :rows="3" readonly class="field-input" />
              <el-button size="small" type="primary" @click="copyField('dy_password', promoteResult.dy_password)">
                复制
              </el-button>
            </div>
          </div>
          <div class="promote-field">
            <label>抖音 Deeplink</label>
            <div class="field-value">
              <el-input :value="promoteResult.dy_deeplink" type="textarea" :rows="3" readonly class="field-input" />
              <el-button size="small" type="primary" @click="copyField('dy_deeplink', promoteResult.dy_deeplink)">
                复制
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="promoteDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout/index";
import { getDyHighCommissionList, getDouyinUrl, getDouyinFullSearch, douyinGoodsInfo, getUrlCpm } from "@/api/public";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      // 时间筛选
      timeList: [
        {
          name: "近24小时",
          value: "1",
        },
        {
          name: "近7天",
          value: "2",
        },
      ],
      timeEnum: "1",

      // 类目筛选
      categoryList: [
        {
          name: "综合推荐",
          value: "0",
        },
        {
          name: "食品饮料",
          value: "1",
        },
        {
          name: "服饰配饰",
          value: "2",
        },
        {
          name: "美妆日化",
          value: "3",
        },
        {
          name: "家居日用",
          value: "4",
        },
      ],
      categoryEnum: "0",

      // 排序
      sortField: "", // 排序字段：sales_num, final_price, tkrates_raw
      sortOrder: "desc", // 排序顺序：asc, desc

      // 数据
      goodsList: [],
      loading: false,

      // 搜索相关
      searchKeyword: "",
      isSearchMode: false, // 是否为搜索模式
      searchList: [], // 搜索结果列表
      searchRequestId: null, // 搜索分页request_id
      searchPageSize: 20, // 搜索分页大小
      searchLoading: false, // 搜索加载状态
      suggestTimer: null, // 搜索联想防抖定时器

      // 无品推荐相关（基于 origin_id 的兜底推荐）
      noProductRecommendList: [], // 无品推荐商品列表
      noProductRecommendLoading: false, // 无品推荐加载状态
      showNoProductRecommend: false, // 是否显示无品推荐

      // 默认图片
      defaultImage: "https://img.huajuanyun.com/utools/2025/711/1752201507730.png",

      // 推广相关
      promoteDialogVisible: false,
      promoteLoading: false,
      promoteResult: null,
    };
  },
  computed: {
    // 当前显示的商品列表（搜索模式或普通模式）
    currentGoodsList() {
      if (this.isSearchMode) {
        // 如果显示无品推荐，优先显示无品推荐列表
        if (this.showNoProductRecommend && this.noProductRecommendList.length > 0) {
          return this.noProductRecommendList;
        }
        return this.searchList;
      }
      return this.goodsList;
    },
    // 排序后的商品列表
    sortedGoodsList() {
      const list = this.currentGoodsList;

      if (!this.sortField) {
        return list;
      }

      // 使用slice创建新数组，避免修改原数组
      const sortedList = list.slice();
      const field = this.sortField;
      const order = this.sortOrder;

      return sortedList.sort((a, b) => {
        let valueA = a[field];
        let valueB = b[field];

        // 处理空值
        if (valueA === null || valueA === undefined || valueA === "") {
          valueA = 0;
        }
        if (valueB === null || valueB === undefined || valueB === "") {
          valueB = 0;
        }

        // 转换为数字
        valueA = parseFloat(valueA) || 0;
        valueB = parseFloat(valueB) || 0;

        // 排序
        if (order === "asc") {
          return valueA - valueB;
        } else {
          return valueB - valueA;
        }
      });
    },
  },
  created() {
    // 初始化
  },
  mounted() {
    this.init();
    // 监听滚动事件，实现搜索结果的自动加载更多
    window.addEventListener("scroll", this.handleScrollLoadMore, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollLoadMore);
  },
  methods: {
    // 联想搜索（下拉词）- 使用 JSONP，并且只在输入变更时触发
    querySearchAsync(queryString, cb) {
      const keyword = String(queryString == null ? "" : queryString).trim();
      if (!keyword) {
        cb([]);
        return;
      }

      // 防抖，减少请求次数
      if (this.suggestTimer) {
        clearTimeout(this.suggestTimer);
      }

      this.suggestTimer = setTimeout(() => {
        const callbackName = `tbSugCb_${Date.now()}_${Math.floor(Math.random() * 100000)}`;
        const url = `https://suggest.taobao.com/sug?k=1&area=c2c&code=utf-8&q=${encodeURIComponent(
          keyword
        )}&callback=${callbackName}`;

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;

        // 定义全局回调，用于接收 JSONP 数据
        window[callbackName] = (res) => {
          try {
            const list = Array.isArray(res && res.result)
              ? res.result.map((item) => ({
                  value: item[0],
                }))
              : [];
            cb(list);
          } catch (e) {
            console.error("解析联想词失败:", e);
            cb([]);
          } finally {
            delete window[callbackName];
            if (script && script.parentNode) {
              script.parentNode.removeChild(script);
            }
          }
        };

        script.onerror = () => {
          delete window[callbackName];
          if (script && script.parentNode) {
            script.parentNode.removeChild(script);
          }
          cb([]);
        };

        document.body.appendChild(script);
      }, 200);
    },

    // 选中联想词
    handleSuggestSelect(item) {
      if (item && item.value) {
        this.searchKeyword = item.value;
        this.handleSearch();
      }
    },

    // 初始化
    init() {
      this.getGoodsList();
    },

    // 获取商品列表
    async getGoodsList() {
      this.loading = true;

      try {
        const params = {
          time_enum: this.timeEnum,
          category_enum: this.categoryEnum,
        };

        const response = await getDyHighCommissionList(params);

        if (response && response.data && response.data.list) {
          this.goodsList = response.data.list;
        } else {
          this.goodsList = [];
        }
      } catch (error) {
        console.error("获取商品列表失败:", error);
        this.goodsList = [];
        this.$message.error("数据加载失败");
      } finally {
        this.loading = false;
      }
    },

    // 时间切换
    handleTimeChange(value) {
      this.timeEnum = value;
      this.getGoodsList();
    },

    // 类目切换
    handleCategoryChange(value) {
      this.categoryEnum = value;
      this.getGoodsList();
    },

    // 排序点击处理
    handleSortClick(field, order) {
      if (order) {
        // 如果指定了排序顺序，直接设置
        this.sortField = field;
        this.sortOrder = order;
      } else {
        // 如果只点击了字段，切换排序顺序
        if (this.sortField === field) {
          // 如果当前已经是这个字段，切换升序/降序
          this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
        } else {
          // 如果是新字段，默认降序
          this.sortField = field;
          this.sortOrder = "desc";
        }
      }
    },

    // 搜索处理
    async handleSearch() {
      if (!this.searchKeyword || !this.searchKeyword.trim()) {
        this.$message.warning("请输入搜索关键词");
        return;
      }

      // 关闭autocomplete下拉框
      if (this.$refs.searchAutocomplete) {
        this.$refs.searchAutocomplete.close();
      }

      this.isSearchMode = true;
      this.searchRequestId = null;
      this.searchList = [];
      await this.getSearchList();
    },

    // 搜索清除
    handleSearchClear() {
      this.isSearchMode = false;
      this.searchKeyword = "";
      this.searchList = [];
      this.searchRequestId = null;
      this.showNoProductRecommend = false;
      this.noProductRecommendList = [];
    },

    // 获取搜索结果
    async getSearchList() {
      this.searchLoading = true;

      // 记录本次是否为首页搜索（没有 request_id）
      const isFirstPage = !this.searchRequestId;

      try {
        const params = {
          keyword: this.searchKeyword.trim(),
          pagesize: this.searchPageSize,
        };

        if (this.searchRequestId) {
          params.request_id = this.searchRequestId;
        }

        const response = await getDouyinFullSearch(params);

        if (response && response.data) {
          const list = response.data.list || [];

          if (this.searchRequestId) {
            // 加载更多，追加数据
            this.searchList = [...this.searchList, ...list];
          } else {
            // 首次搜索，替换数据
            this.searchList = list;
          }

          // 保存request_id用于分页
          this.searchRequestId = response.data.request_id;

          // 如果只有一条结果，且is_dy_cpm为true，请求商品详情获取pgl_rate
          if (isFirstPage && this.searchList.length === 1 && this.searchList[0].is_dy_cpm) {
            await this.fetchGoodsInfoForSingleResult(this.searchList[0]);
          }

          if (isFirstPage) {
            // 首次搜索结束后的处理逻辑

            if (this.searchList.length === 0) {
              // 如果搜索结果为空，请求无品推荐
              await this.getNoProductRecommend();
            } else {
              // 有搜索结果时，重置无品推荐状态
              this.showNoProductRecommend = false;
              this.noProductRecommendList = [];
            }
          }
        } else {
          if (isFirstPage) {
            this.searchList = [];
            // 搜索结果为空，请求无品推荐
            await this.getNoProductRecommend();
          } else {
            this.$message.warning("未找到相关商品");
          }
        }
      } catch (error) {
        console.error("搜索失败:", error);
        this.searchList = [];
        this.$message.error("搜索失败，请稍后重试");
      } finally {
        this.searchLoading = false;
      }
    },

    // 基于 keyword 的高佣库搜索结果
    async getHighCommissionSearch() {
      if (!this.searchKeyword || !this.searchKeyword.trim()) {
        return [];
      }

      try {
        const params = {
          keyword: this.searchKeyword.trim(),
        };

        const response = await getUrlCpm(params);

        if (response && response.data && Array.isArray(response.data.list)) {
          return response.data.list;
        }
        return [];
      } catch (error) {
        console.error("获取高佣库搜索结果失败:", error);
        return [];
      }
    },

    // 为单条搜索结果获取商品详情（获取pgl_rate）
    async fetchGoodsInfoForSingleResult(item) {
      if (!item.origin_id) {
        return;
      }

      try {
        const response = await douyinGoodsInfo({
          origin_id: item.origin_id,
        });

        if (response && response.data && response.data.pgl_rate !== undefined) {
          // 将pgl_rate添加到商品数据中
          this.$set(item, "pgl_rate", response.data.pgl_rate);
        }
      } catch (error) {
        console.error("获取商品详情失败:", error);
      }
    },

    // 加载更多搜索结果
    async loadMoreSearch() {
      if (this.searchRequestId) {
        await this.getSearchList();
      }
    },

    // 滚动自动加载更多
    handleScrollLoadMore() {
      // 仅在搜索模式下启用自动加载
      if (!this.isSearchMode) return;
      // 无品推荐模式下不再自动加载搜索结果
      if (this.showNoProductRecommend) return;
      // 没有下一页 request_id 时不加载
      if (this.searchRequestId === null || this.searchRequestId === undefined) return;
      // 正在加载中时不重复触发
      if (this.searchLoading) return;

      const scrollContainer = window;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const fullHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      // 距离底部 200px 以内时触发加载更多
      const threshold = 200;
      if (scrollTop + viewportHeight + threshold >= fullHeight) {
        this.loadMoreSearch();
      }
    },

    // 获取无品推荐
    async getNoProductRecommend() {
      if (!this.searchKeyword || !this.searchKeyword.trim()) {
        return;
      }

      this.noProductRecommendLoading = true;
      this.showNoProductRecommend = false;
      this.noProductRecommendList = [];

      try {
        const params = {
          origin_id: this.searchKeyword.trim(),
          need_rec_products: 1,
        };

        const response = await getUrlCpm(params);

        if (response && response.data && response.data.list) {
          const list = response.data.list || [];
          if (list.length > 0) {
            this.noProductRecommendList = list;
            this.showNoProductRecommend = true;
          }
        }
      } catch (error) {
        console.error("获取无品推荐失败:", error);
      } finally {
        this.noProductRecommendLoading = false;
      }
    },

    // 处理商品点击 - 立即推广
    async handleGoodsClick(item) {
      if (!item.origin_id) {
        this.$message.warning("商品ID不存在");
        return;
      }

      this.promoteLoading = true;
      this.promoteDialogVisible = true;
      this.promoteResult = null;

      try {
        const response = await getDouyinUrl({
          origin_id: item.origin_id,
        });

        if (response && response.data) {
          this.promoteResult = {
            dy_password: response.data.dy_password || "",
            dy_deeplink: response.data.dy_deeplink || "",
          };
        } else {
          this.$message.error("获取推广链接失败");
        }
      } catch (error) {
        console.error("获取推广链接失败:", error);
        this.$message.error("获取推广链接失败，请稍后重试");
      } finally {
        this.promoteLoading = false;
      }
    },
    async handleOpenGoods(item) {
      if (!item.detail_url) {
        this.$message.warning("商品详情页链接不存在");
        return;
      }
      try {
        window.open(item.detail_url+'&origin_type=pc_buyin_group', "_blank");
      } catch (error) {
        console.error("打开商品详情页失败:", error);
        this.$message.error("打开商品详情页失败，请稍后重试");
      }
    },
    // 复制字段
    copyField(fieldName, value) {
      if (!value) {
        this.$message.warning("内容为空，无法复制");
        return;
      }

      this.$copyText(value)
        .then(() => {
          this.$message.success(`${fieldName === "dy_password" ? "抖音口令" : "Deeplink"}复制成功`);
        })
        .catch(() => {
          this.$message.error("复制失败，请手动复制");
        });
    },

    // 关闭推广弹窗
    handlePromoteDialogClose() {
      this.promoteResult = null;
    },

    // 格式化数字
    formatNumber(num) {
      if (!num) return "0";
      const number = parseFloat(num);
      if (isNaN(number)) return "0";
      return number.toFixed(2);
    },

    // 格式化销量
    formatSales(num) {
      if (!num) return "0";
      const number = Number(num);
      if (isNaN(number)) return num || "0";
      if (number >= 10000) {
        return (number / 10000).toFixed(1) + "万";
      }
      return number.toString();
    },

    // 提取真实商品ID
    extractRealGoodsId(originId) {
      if (!originId) return "-";

      try {
        // URL解码
        const decodedId = decodeURIComponent(originId);
        // 分割字符串
        const parts = decodedId.split("|");
        // 如果格式为 "type|goodsId|..." 则返回第二部分
        if (parts.length >= 2) {
          return parts[1];
        }
        // 如果不符合预期格式，返回原始ID
        return originId;
      } catch (error) {
        console.error("解析商品ID出错:", error);
        return originId;
      }
    },

    // 复制商品ID
    copyGoodsId(id) {
      if (!id) return;

      const realId = this.extractRealGoodsId(id);

      this.$copyText(realId).then(
        () => {
          this.$message.success("商品ID复制成功");
        },
        () => {
          this.$message.error("复制失败，请手动复制");
        }
      );
    },
    copyGoodsLink(link) {
      if (!link) return;
      this.$copyText(link).then(
        () => {
          this.$message.success("商品链接复制成功");
        },
        () => {
          this.$message.error("复制失败，请手动复制");
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.dygaoyong-page {
  padding: 20px;
  min-height: calc(100vh - 60px);
  background-color: #f8f9fa;
}

.page-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px 0 60px;

  .header-search {
    .search-input-large {
      width: 700px;

      ::v-deep .el-input__inner {
        font-size: 16px;
        padding: 22px 15px 23px;
      }
      ::v-deep .el-button {
        color: #ffffff;
        border-radius: 0 6px 6px 0;
        border: none;
        padding: 15px 15px;
        font-size: 16px;
        background-color: var(--main-bg-color);
        &:hover {
          background-color: var(--main-bg-color);
        }
        &:active {
          background-color: var(--main-bg-color);
        }
      }
    }
  }
}

.compact-tip {
  margin-bottom: 20px;
  border-radius: 8px;
  background: #fafbfc;
}

.compact-content {
  font-size: 14px;
  color: #5a6e7c;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.tag {
  display: inline-block;
  padding: 2px 8px;
  background: #ecf5ff;
  color: var(--main-bg-color);
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
}

.tag.limit {
  background: #fdf6ec;
  color: #e6a23c;
}

.divider {
  color: #dcdfe6;
}

.card-container {
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid #ebeef5;

  ::v-deep .el-card__body {
    padding: 20px;
  }
}

.filter-section {
  .filter-group {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    .filter-label {
      font-weight: 500;
      margin-right: 15px;
      min-width: 80px;
      color: #606266;
    }

    .sort-buttons {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    .sort-item {
      display: flex;
      align-items: center;
      gap: 5px;
      margin: 6px 12px;
      //   border: 1px solid #dcdfe6;
      //   border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        color: var(--main-bg-color);
      }

      &.active {
        color: var(--main-bg-color);
      }

      .sort-label {
        font-size: 14px;
        user-select: none;
      }

      .sort-arrows {
        display: flex;
        flex-direction: column;
        margin-left: 4px;

        i {
          font-size: 11px;
          line-height: 1;
          color: #909399;
          transition: color 0.3s;
          cursor: pointer;

          &:hover {
            color: var(--main-bg-color);
          }

          &.active {
            color: var(--main-bg-color);
            font-weight: bold;
          }
        }
      }
    }

    ::v-deep {
      .el-radio-button__inner {
        border-radius: 6px;
        margin-right: 4px;
        border: 1px solid #dcdfe6;
      }

      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        box-shadow: none;
      }
    }
  }
}

.goods-list {
  .empty-data {
    padding: 40px 0;
    text-align: center;
    color: #909399;
    font-size: 14px;
  }

  // 高佣库 keyword 搜索结果样式（已合并到主列表，仅保留标题样式可复用时使用）
  .hc-search-title {
    margin: 0 0 10px 0;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }

  .no-cps-tip {
    padding: 20px;
    text-align: center;
    background: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 4px;
    margin-bottom: 20px;

    p {
      margin: 0;
      color: #856404;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .recommend-title {
    margin-bottom: 20px;
    padding: 15px 20px;
    background: #f0f9ff;
    border-left: 4px solid var(--main-bg-color);
    border-radius: 4px;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #303133;
    }
  }

  .goods-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 15px;
    width: 100%;
    margin: 0 auto;
  }

  .goods-item {
    margin-bottom: 15px;
  }

  .goods-card {
    position: relative;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-height: 360px;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
    }
  }

  .goods-image {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    /* 1:1 比例 */
    position: relative;
    overflow: hidden;
    background-color: #f9f9f9;
    border-bottom: 1px solid #f0f0f0;

    ::v-deep .el-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: 8px 8px 0 0;
        transition: transform 0.3s ease;

        &:hover {
          transform: scale(1.05);
        }
      }
    }

    .image-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: #f5f7fa;
      color: #909399;
      font-size: 24px;
    }
  }

  .goods-content {
    padding: 10px;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .goods-title {
    font-size: 14px;
    color: #222222;
    line-height: 1.4;
    margin-bottom: 5px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 36px;
    cursor: pointer;

    .platform-tag {
      font-weight: normal;
      padding: 0 4px;
      border-radius: 2px;
      margin-right: 3px;
      vertical-align: middle;
      font-size: 13px;
    }

    .cpm-tag {
      margin-left: 5px;
      font-size: 12px;
      padding: 0 6px;
    }
  }

  .commission-rate-comparison {
    margin-bottom: 8px;
    padding: 8px;
    background: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #e4e7ed;

    .rate-item {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      font-size: 13px;

      &:last-child {
        margin-bottom: 0;
      }

      &.highlight {
        .rate-value {
          color: #f56c6c;
          font-weight: bold;
          font-size: 15px;
        }

        .rate-tip {
          margin-left: 8px;
          color: #f56c6c;
          font-weight: bold;
          font-size: 12px;
        }
      }

      .rate-label {
        color: #606266;
        margin-right: 5px;
      }

      .rate-value {
        color: #303133;
        font-weight: 500;
      }
    }
  }

  .price-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  .price-info {
    line-height: 1;
    .current-price {
      color: #e2231a;
      font-weight: bold;

      .price-number {
        font-size: 26px;
      }
    }

    .original-price {
      color: #999;
      font-size: 13px;
      text-decoration: line-through;
      margin-top: 2px;
    }
  }

  .goods-tags {
    text-align: right;
    line-height: 1.2;
    .price-tag {
      font-size: 14px;
      margin-left: 3px;
      margin-bottom: 3px;
      font-weight: bold;
      transform-origin: right center;
    }
    .commission-rate {
      color: #ff3b52;
      font-size: 14px;
      margin-bottom: 3px;
      font-weight: bold;
      transform-origin: right center;
    }
    .commission-text {
      color: #ff9012;
      font-size: 14px;
      transform-origin: right center;
    }
  }
  .sales-info-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .shop-title {
      font-size: 12px;
      color: #8b8b8b;
    }
    .sales-info {
      display: flex;
      align-items: center;
      .sales-text {
        font-size: 12px;
        color: #909399;
      }
    }
  }

  .action-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: auto;
    padding-top: 8px;
    border-top: 1px solid #f0f0f0;

    .el-button {
      padding: 6px 10px;
      font-size: 12px;
    }
    .goods-id {
      .id-text {
        font-size: 12px;
        color: #919191;
        cursor: pointer;
        display: inline-block;

        &:hover {
          text-decoration: underline;
        }

        i {
          margin-right: 3px;
        }
      }
    }
  }
}

.load-more {
  text-align: center;
  padding: 20px 0;

  p {
    margin: 0;
    font-size: 14px;
    color: #909399;
  }

  .loading-text {
    color: var(--main-bg-color);

    i {
      margin-right: 5px;
    }
  }

  .no-more-text {
    color: #909399;
  }

  .load-more-text {
    color: #909399;
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .goods-list {
    .goods-grid {
      grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    }
  }
}

@media (max-width: 1200px) {
  .goods-list {
    .goods-grid {
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
      max-width: 1000px;
    }

    .goods-card {
      min-height: 340px;
    }
  }
}

@media (max-width: 992px) {
  .goods-list {
    .goods-grid {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      max-width: 800px;
    }

    .goods-card {
      min-height: 330px;
    }

    .goods-title {
      min-height: 38px;
      -webkit-line-clamp: 2;
      font-size: 13px;
    }
  }
}

@media (max-width: 768px) {
  .dygaoyong-page {
    padding: 10px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;

    .header-right {
      margin-left: 0;
      margin-top: 15px;
      width: 100%;

      .search-input-large {
        width: 100%;
      }
    }
  }

  .filter-section {
    .filter-group {
      flex-direction: column;
      align-items: flex-start;

      .filter-label {
        margin-bottom: 10px;
      }
    }
  }

  .goods-list {
    .goods-grid {
      grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
      gap: 10px;
    }

    .goods-card {
      min-height: 320px;
    }

    .goods-content {
      padding: 8px;
    }

    .goods-title {
      font-size: 12px;
      margin-bottom: 6px;
      min-height: 34px;
    }

    .price-info {
      .current-price .price-number {
        font-size: 15px;
      }
    }

    .action-row {
      flex-direction: column;
      align-items: flex-start;

      .goods-id {
        margin-bottom: 6px;
      }

      .el-button {
        width: 100%;
        padding: 5px 10px;
        font-size: 12px;
      }
    }
  }
}

@media (max-width: 576px) {
  .goods-list {
    .goods-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
    }

    .goods-card {
      min-height: 300px;
    }

    .goods-title {
      font-size: 12px;
    }
  }
}

// 推广弹窗样式
.promote-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px;
  }
}

.promote-result {
  min-height: 200px;

  .promote-fields {
    .promote-field {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      label {
        display: block;
        margin-bottom: 8px;
        font-weight: 500;
        color: #606266;
        font-size: 14px;
      }

      .field-value {
        display: flex;
        gap: 10px;
        align-items: flex-start;

        .field-input {
          flex: 1;

          ::v-deep .el-textarea__inner {
            font-family: "Courier New", monospace;
            font-size: 12px;
            line-height: 1.5;
          }
        }

        .el-button {
          white-space: nowrap;
        }
      }
    }
  }
}
/* 针对 single-goods-card 的特殊布局 */
.single-goods-card {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)) !important;
}
.commission-pk-container {
  display: flex;
  align-items: stretch; // 让左右高度一致
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  .pk-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 4px;
    position: relative;

    &.loser {
      background: #f5f7fa;
      color: #333333;

      .label {
        font-size: 12px;
        margin-bottom: 2px;
      }
      .value {
        font-size: 14px;
        font-weight: 500;
      }
    }

    &.winner {
      background: #fff1f0; // 浅红色背景烘托
      color: #f12727;
      flex: 1.3; // 让赢家占据更大空间

      .badge {
        position: absolute;
        top: 0;
        right: 0;
        background: #f12727;
        color: #fff;
        font-size: 10px;
        padding: 1px 6px;
        border-bottom-left-radius: 6px;
      }

      .label {
        font-size: 14px;
        opacity: 0.8;
        margin-bottom: 2px;
      }

      .value-group {
        display: flex;
        align-items: baseline;

        .num {
          font-size: 20px; // 放大数字
          font-weight: bold;
          line-height: 1;
        }

        .up-tag {
          font-size: 14px;
          background: #e23232;
          color: white;
          padding: 1px 4px;
          border-radius: 4px;
          margin-left: 4px;
          transform: scale(0.9);
        }
      }
    }
  }

  .pk-divider {
    width: 0;
    position: relative;
    z-index: 1;

    .vs-tag {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      border: 1px solid #e4e7ed;
      color: #c0c4cc;
      font-size: 10px;
      padding: 2px;
      border-radius: 50%;
      font-weight: bold;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
